import HelpStep from '../components/HelpStep';
import IconStep from '../components/IconStep';
import ReasonStep from '../components/ReasonStep';
import { AssistRenderType } from '../types';

const stepByRenderType = (renderType: AssistRenderType) => {
  switch (renderType) {
    case 'popup_help':
      return HelpStep;
    case 'popup_icon':
      return IconStep;
    case 'popup_reason':
      return ReasonStep;
    default: {
      const Empty = () => null;
      return Empty;
    }
  }
};

export default stepByRenderType;
